import React, {useContext} from 'react';
import {Form, Formik} from 'formik';
import {Button, Grid, TextField} from '@material-ui/core';
import ErrorBoundaryForComponents from '../../../../util/ErrorBoundaryForComponents';
import EventClientSearchTable from './SearchEventClientTable';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import GuiAutoComplete from '../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../components/FormComponents/GuiTextField';

const SearchEventClient = ({setValue, value}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  // const handleSubmit = (data) => {
  // };

  const initialValues = {
    clientId: '',
    eventTactic: '',
    agency: '',
    eventType: '',
  };
  const eventTypeOptions = [
    {value: 'Debtor User-Defined Window Updated'},
    {value: 'Disposition Change'},
    {value: 'New Business Approved'},
    {value: 'Phase Change'},
    {value: 'Number of Calls Updated'},
    {value: 'Debtor Cash Transaction Updated'},
    {value: 'Letter Requested'},
    {value: 'Letter Sent'},
    {value: 'Receipt of NSF'},
  ];

  return (
    <>
      <div className={`${classes.tabCardStyles} mb-0`}>
        <Formik
          // onSubmit={(values) => handleSubmit(values)}
          initialValues={initialValues}
          enableReinitialize
        >
          {(props) => {
            const {values, handleChange, resetForm, handleBlur, setFieldValue} = props;
            return (
              <div className={classes.ruleGroupCard}>
                <Form autoComplete="off" noValidate>
                  <div>
                    <ErrorBoundaryForComponents>
                      <Grid spacing={2} container>
                        <Grid item md={4} sm={6} className="form-group">
                          <TextField
                            margin="dense"
                            variant="outlined"
                            className={` ${classes.labelName} ${classes.inputLabel}`}
                            placeholder={`Enter Client ID`}
                            label="Client ID"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="clientId"
                            value={values.clientId}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                          />
                        </Grid>
                        <Grid item md={4} sm={6} className="form-group">
                          <TextField
                            className={` ${classes.labelName} ${classes.inputLabel}`}
                            margin="dense"
                            variant="outlined"
                            name="eventTactic"
                            placeholder={`Enter Event Tactic`}
                            label="Event Tactic"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            value={values.eventTactic}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                          />
                        </Grid>
                        <Grid item md={4} sm={6} className="form-group">
                          <TextField
                            className={` ${classes.labelName} ${classes.inputLabel}`}
                            margin="dense"
                            variant="outlined"
                            name="agency"
                            placeholder={`Enter Agency`}
                            label="Agency"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            value={values.agency}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                          />
                        </Grid>
                        <Grid item md={4} sm={6} className="form-group">
                          <GuiAutoComplete
                            classes={{
                              popper: classes.popper,
                              option: classes.option,
                            }}
                            name="eventType"
                            id="eventType"
                            size="small"
                            value={values.eventType}
                            options={eventTypeOptions}
                            getOptionDisabled={(option) => option.valueCode === null}
                            getOptionLabel={(option) => {
                              return option?.value ?
                                option?.value :
                                option?.value === undefined ?
                                  option :
                                  option.value;
                            }}
                            required
                            onChange={(e, value) => {
                              handleChange(e);
                              setFieldValue('eventType', value);
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  className={` ${classes.labelName} ${classes.selectLabel}`}
                                  {...params}
                                  variant="outlined"
                                  margin="dense"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  label="Event Type"
                                  placeholder="Select Event Type"
                                />
                              </div>
                            )}
                          />
                        </Grid>
                      </Grid>
                      <div className="button-table-spacing-mb">
                        <Button
                          variant="contained"
                          className={`mx-1 ${classes.buttonRoot}`}
                          onClick={() => {
                            resetForm();
                          }}
                        >
                          Clear
                        </Button>
                        <Button
                          variant="contained"
                          type="submit"
                          className={`themeing-buttons mx-1 ${classes.buttonRoot}`}
                        >
                          Search
                        </Button>
                      </div>
                    </ErrorBoundaryForComponents>
                  </div>
                </Form>
              </div>
            );
          }}
        </Formik>
        <EventClientSearchTable setValue={setValue} />
      </div>
    </>
  );
};
export default SearchEventClient;
